import { escapeRegExp, flatten } from "lodash";
import { Template, TemplatePart } from "./chatInputUtilsTypes";

const compileTemplatePart = <T extends {}>(
  template: Template<T>,
  templatePart: TemplatePart<T>
) => {
  if (typeof template !== "string") {
    return template;
  }

  const brokenTemplates = template.split(new RegExp(escapeRegExp(templatePart.key), "g"));

  return flatten(brokenTemplates.map((bn) => [bn, templatePart])).slice(0, -1);
};

export const compileTemplate = <T>(templates: Template<T>[], templateParts: TemplatePart<T>[]) =>
  templateParts.reduce(
    (compiledTemplates, part) =>
      flatten(
        compiledTemplates.map((template: Template<T>) => compileTemplatePart(template, part))
      ),
    templates
  );
